import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';

const ALLOWED_ELEVATED = new Set(['cashier', 'superadmin', 'admin', 'subadmin']);

interface RoleGateProps {
  role?: string;
}

/** Allow the cashier role (and superadmin/admin pass-through) to reach the POS. */
export function RoleGate({ role = 'cashier' }: RoleGateProps) {
  const user = useAuthStore((s) => s.user);
  const ok = user && (user.role === role || ALLOWED_ELEVATED.has(user.role));

  if (!ok) {
    return <Navigate to="/login" replace state={{ error: 'ROLE_NOT_ALLOWED' }} />;
  }
  return <Outlet />;
}
